import Vue from 'vue';

export class ServerCommon {

  public static getUid(): Promise<any> {

    return new Promise((resolve, reject) => {

      Vue.axios({
        url: '/v1/auth/get-uid',
        method: 'GET',
      })
        .then((resp: any) => {
          resolve(resp.data.uid);
        })
        .catch((err: any) => {
          reject(err);
        });

    })

  }

}

